import * as z from "zod/v4";

const ProductDiffValuesSchema_ = z.object({
  title: z.string().nullable().optional(),
  sku: z.string().nullable().optional(),
  price: z.number().nullable().optional(),
  vendor: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  weightGrams: z.number().nullable().optional(),
  upc: z.string().nullable().optional(),
  tags: z.array(z.string()).nullable().optional(),
  cost: z.number().nullable().optional(),
  originCountry: z.string().nullable().optional(),
  hsCode: z.string().nullable().optional(),
});

export const getCatalogAgentOperationDiff = {
  name: "getCatalogAgentOperationDiff" as const,
  input: z.object({ toolCallId: z.string() }),
  output: z.object({
    operations: z.array(
      z.object({
        id: z.coerce.string(),
        productId: z.coerce.string(),
        displayName: z.string(),
        changeKind: z.enum(["create", "update", "delete"]),
        classification: z.enum([
          "clean",
          "conflict",
          "already-gone",
          "already-undone",
        ]),
        oldValues: ProductDiffValuesSchema_.nullable(),
        newValues: ProductDiffValuesSchema_.nullable(),
        currentValues: ProductDiffValuesSchema_.nullable(),
      }),
    ),
  }),
};
